import { render } from "./studio.vue?vue&type=template&id=408c8fe6&scoped=true&ts=true"
import script from "./studio.vue?vue&type=script&lang=ts"
export * from "./studio.vue?vue&type=script&lang=ts"

import "./studio.vue?vue&type=style&index=0&id=408c8fe6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408c8fe6"]])

export default __exports__